import React from "react";
import { BackPage } from "./TableFlyer";

// Standalone, chrome-free Back page at full 8.5×11 (816×1056) resolution.
// Open this URL and right-click the image → "Save image as…" or screenshot it.
export default function TableFlyerBack() {
  return (
    <div
      data-testid="tableflyer-back-standalone"
      className="min-h-screen w-full bg-black flex items-start justify-center"
      style={{ padding: 0 }}
    >
      <BackPage />
    </div>
  );
}
